import type { PartCatalogSummaryDto, PartCategory } from '@bhops/shared';

// 로봇 상세 '부품' 탭 — 부품 분류 이름과, 끌어다 놓아 장착할 때 미리 채우는 슬롯.
// 슬롯은 서버에서 자유 글자지만, 같은 슬롯에 이미 끼워진 부품은 서버가 UPGRADE 사유로
// 자동 제거하므로(parts.service installPart) 기본값을 분류마다 고정해 둔다.

export const CATEGORY_LABEL: Record<PartCategory, string> = {
  GRILLER: '그릴러',
  LOADER: '로더',
  GAS_VALVE: '가스 밸브',
  FIRMWARE_BOARD: '펌웨어 보드',
  SENSOR_SUITE: '센서 모듈',
  POWER_UNIT: '전원 유닛',
  CONSUMABLE: '소모품',
  ACCESSORY: '액세서리',
};

// 권장 slot 값 — datalist 로 자동완성. 로더(MAIN/BACKUP_LOADER)는 전용 '로더' 탭에서
// 관리하므로 여기서 제외(docs/plan/loader-history-traceability-2026-07 §4.2).
export const SLOT_SUGGESTIONS = [
  'PRIMARY_GRILLER',
  'BACKUP_GRILLER',
  'GAS_VALVE',
  'FIRMWARE_BOARD',
  'SENSOR_FRONT',
  'SENSOR_REAR',
  'POWER_UNIT',
];

// 분류마다 차례로 쓰는 슬롯. 한 번에 같은 분류를 둘 놓으면 두 번째 칸으로 간다.
// 소모품 · 액세서리는 정해진 자리가 없어 SKU 를 슬롯으로 쓴다(같은 품목끼리만 교체).
const CATEGORY_SLOTS: Partial<Record<PartCategory, string[]>> = {
  GRILLER: ['PRIMARY_GRILLER', 'BACKUP_GRILLER'],
  GAS_VALVE: ['GAS_VALVE'],
  FIRMWARE_BOARD: ['FIRMWARE_BOARD'],
  SENSOR_SUITE: ['SENSOR_FRONT', 'SENSOR_REAR'],
  POWER_UNIT: ['POWER_UNIT'],
};

/**
 * 한 번에 놓은 부품들의 기본 슬롯. 같은 묶음 안에서 슬롯이 겹치지 않게 나눈다 —
 * 겹치면 뒤의 것이 앞의 것을 곧바로 교체해 버린다.
 */
export function defaultSlots(
  catalogs: Pick<PartCatalogSummaryDto, 'category' | 'sku'>[],
): string[] {
  const used = new Set<string>();
  return catalogs.map((c) => {
    const choices = CATEGORY_SLOTS[c.category] ?? [c.sku.toUpperCase()];
    let slot = choices.find((s) => !used.has(s));
    if (!slot) {
      const base = choices[choices.length - 1];
      let n = 2;
      while (used.has(`${base}_${n}`)) n += 1;
      slot = `${base}_${n}`;
    }
    used.add(slot);
    return slot;
  });
}
